import { jsx as _jsx } from "react/jsx-runtime";
import { Icon, InputRightElement } from '@chakra-ui/react';
import { BxsChevronDown, BxsChevronUp } from '../../../icons';
import { useSelectContext } from '../../SelectContext';
export const ToggleChevron = () => {
    const { isOpen, getToggleButtonProps, isDisabled, isReadOnly, styles } = useSelectContext();
    return (_jsx(InputRightElement, { as: "button", type: "button", display: "flex", _disabled: {
            cursor: 'not-allowed',
        }, "aria-label": `${isOpen ? 'Close' : 'Open'} dropdown options`, ...getToggleButtonProps({
            disabled: isDisabled || isReadOnly,
            // Allow navigation to this button with screen readers.
            tabIndex: 0,
        }), children: _jsx(Icon, { sx: styles.icon, as: isOpen ? BxsChevronUp : BxsChevronDown, "aria-disabled": isDisabled || isReadOnly }) }));
};
// So input group knows to add right padding to the inner input.
ToggleChevron.id = InputRightElement.id;
